module.exports = __webpack_public_path__ + "static/media/badge.cf40ec42.svg";